import Vue from "vue";
import Element from "element-ui";
import locale from "element-ui/lib/locale/lang/en";
// import "element-ui/lib/theme-chalk/index.css";
// 自定义主题
import "@/static/element/index.css";

Vue.use(Element, { locale });
